import type { Incident, IncidentStatus } from '../../incidents/types/incident.types'
import type { ShiftKpis, ShiftResponse } from '../types/shift.types'

const RESOLVED_STATUSES: ReadonlySet<IncidentStatus> = new Set(['DONE', 'CLOSED'])
const PENDING_STATUSES: ReadonlySet<IncidentStatus> = new Set(['NEW', 'ACKNOWLEDGE', 'IN_PROGRESS'])

export function aggregateShiftKpis(
  incidents: Incident[],
  shift: ShiftResponse,
  now: Date = new Date(),
): ShiftKpis {
  const start = new Date(shift.started_at).getTime()
  const end = shift.ended_at ? new Date(shift.ended_at).getTime() : now.getTime()

  const inWindow = incidents.filter((i) => {
    const created = new Date(i.created_at).getTime()
    return created >= start && created <= end
  })

  const total = inWindow.filter((i) => i.status !== 'DRAFT').length
  const resolved = inWindow.filter((i) => RESOLVED_STATUSES.has(i.status)).length
  const pending = inWindow.filter((i) => PENDING_STATUSES.has(i.status)).length
  const efficiencyPct = total === 0 ? 0 : Math.round((resolved / total) * 100)

  return { total, resolved, pending, efficiencyPct }
}
